"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const idm_dynamic_controls_metadata_1 = require("@synisys/idm-dynamic-controls-metadata");
const common_helper_functions_1 = require("../../shared/common-helper-functions");
const idm_common_util_frontend_1 = require("@synisys/idm-common-util-frontend");
const Subject_1 = require("rxjs/Subject");
const idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
const idm_message_language_service_client_js_1 = require("@synisys/idm-message-language-service-client-js");
const operators_1 = require("rxjs/operators");
const rich_text_state_1 = require("../model/rich-text-state");
const Observable_1 = require("rxjs/Observable");
let RichTextBuilderComponent = class RichTextBuilderComponent {
    constructor(currentLanguageProvider, languageService, communicationService) {
        this.currentLanguageProvider = currentLanguageProvider;
        this.languageService = languageService;
        this.communicationService = communicationService;
        this.initialized = false;
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(currentLanguageProvider);
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(languageService);
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(communicationService);
        this.stateChange = new core_1.EventEmitter();
        this.destroy$ = new Subject_1.Subject();
        this.loadLanguages();
    }
    set state(state) {
        if (state !== this.richTextStateEmitted || !this.richTextStateEmitted) {
            this.richTextState = rich_text_state_1.RichTextState.fromJSON(state);
            this.title = this.richTextState.title;
        }
    }
    ngAfterViewInit() {
        this.initialized = true;
    }
    ngOnDestroy() {
        this.destroy$.next(true);
        this.destroy$.complete();
    }
    loadLanguages() {
        this.languageService.getAvailableLanguages()
            .pipe(operators_1.takeUntil(this.destroy$))
            .catch((err) => {
            return Observable_1.Observable.fromPromise(common_helper_functions_1.defaultPromiseErrorHandler(err));
        })
            .subscribe((languages) => {
            this.languages = languages;
        });
        this.currentLanguageProvider.getCurrentLanguage()
            .pipe(operators_1.takeUntil(this.destroy$))
            .catch((err) => {
            return Observable_1.Observable.fromPromise(common_helper_functions_1.defaultPromiseErrorHandler(err));
        })
            .subscribe((language) => {
            this.currentLanguage = language;
        });
    }
    onTitleChange(title) {
        this.title = title;
        this.richTextState.title = this.title;
        this.emitState();
    }
    emitState() {
        this.richTextStateEmitted = this.richTextState.toJSON();
        this.stateChange.emit(this.richTextStateEmitted);
        this.preview();
    }
    preview() {
        let communicationData = new idm_dynamic_controls_metadata_1.CommunicationData(idm_dynamic_controls_metadata_1.CommunicationKey.PREVIEW);
        this.communicationService.parentSubject.next(communicationData);
    }
};
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], RichTextBuilderComponent.prototype, "id", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [Object])
], RichTextBuilderComponent.prototype, "state", null);
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], RichTextBuilderComponent.prototype, "stateChange", void 0);
RichTextBuilderComponent = __decorate([
    core_1.Component({
        
        selector: 'sis-rich-text-builder',
        template: require('./rich-text-builder.component.html'),
        styles: [require('./rich-text-builder.component.css')],
    }),
    idm_dynamic_controls_metadata_1.ControlMetadata({
        template: "<sis-rich-text-builder [id]='%{id}' [state]='%{state}' (stateChange)='%{stateChange}'></sis-rich-text-builder>",
    }),
    __metadata("design:paramtypes", [idm_session_data_provider_api_js_1.CurrentLanguageProvider,
        idm_message_language_service_client_js_1.LanguageService,
        idm_dynamic_controls_metadata_1.CommunicationService])
], RichTextBuilderComponent);
exports.RichTextBuilderComponent = RichTextBuilderComponent;
//# sourceMappingURL=rich-text-builder.component.js.map